import { useState, useEffect } from "react";
import LeftColumn from "./components/leftColumn/leftcolumn";
import RightColumn from "./components/rightcolumn/rightcolumn";
import "./main.css";
import Navbar from "./components/navbar/navbar";
import CloudNavbar from "./components/navbar/cloudNavbar"
import { HashRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Layout from "./components/rightcolumn/layout/layout";
import LayoutSelection from "./layoutselection";
import httpService from "./services/http.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Faq from "./components/FAQ/faq";
// import AdminDashboard from "./components/dashboard/AdminDashboard";
import AdminApp from "./components/dashboard/adminDashboard/adminApp";
import AdminNavbar from "./components/navbar/adminNavbar";
import Preview from "./components/rightcolumn/preview/preview";
import AdminLogin from "./components/authentication/adminlogin";
// import LicenseError from "./components/licenseError/licenseerror";
import UploadFile from "./components/setting/uploadCsvFile";
import ProtectedRoute from "./components/authentication/ProtectedRoute";
import CloudLogin from "./components/authentication/clouduserlogin";
import CloudApp from "./components/dashboard/cloudDashboard/cloudApp";
import Version from "./components/navbar/cloudversions/version";

// new design---
import ChannelsListDashboard from "./components/dashboard/cloudDashboard/propertyDashboard/channelsListDashboard";
import RuleDashboard from "./components/dashboard/cloudDashboard/propertyDashboard/ruleDashboard";
import CloudSettings from "./components/setting/setting";
import CreateAccountPage from "./components/authentication/createUser";
import PaymentSuccessful from "./components/authentication/stripe pages/paymentSuccessful";
import PaymentFailed from "./components/authentication/stripe pages/paymentFailed";
import ForgetPassword from "./components/authentication/forgetPassword";
import ShakaPlayer from "./components/rightcolumn/shakaPlayer";
import PropertyManagerLayout from "./components/dashboard/property manager dashboard/PropertyManagerLayout";


let interval = setInterval(() => { }, 60000);

function App(props) {
  const [rightContentType, setrightContentType] = useState("preview");
  const [layoutCheck, setlayoutCheck] = useState(false);
  const [layoutType, setlayoutType] = useState("3");
  const [borderColorProp, setborderColorProp] = useState("");
  const [borderWidthProp, setborderWidthProp] = useState("");
  const [selectedLayoutID, setselectedLayoutID] = useState("");
  // const [errorPage, setErrorPage] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  // const [license, setLicense] = useState({});
  const [refreshTime, setRefreshTime] = useState(0);
  const [setLogin] = useState(localStorage.getItem("isSession") || 'false');
  const [verifyToken, setVerifyToken] = useState(true)
  const [verifyTokenUser, setVerifyTokenUser] = useState(true)

  useEffect(() => {
    getLatestdata()
    getLatestdata1()
  }, []);
  document.onkeydown = (e) => {
    if (e.key == 123) {
      e.preventDefault();
    }
    if (e.key == 'F12') {
      e.preventDefault();
    }
    if (e.ctrlKey && e.shiftKey && e.key == 'I') {
      e.preventDefault();
    }
    if (e.ctrlKey && e.shiftKey && e.key == 'C') {
      e.preventDefault();
    }
    if (e.ctrlKey && e.shiftKey && e.key == 'J') {
      e.preventDefault();
    }
    if (e.ctrlKey && e.key == 'U') {
      e.preventDefault();
    }
  };
  const getLatestdata = async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    await httpService.get("getRefreshTime").then((res) => {
      setRefreshTime(res.data.ack === "1" ? res.data.data : 10);
      localStorage.setItem(
        "refreshTime",
        res.data.ack === 1 ? res.data.data : 10
      );
    })
      .catch((e) => {
        setRefreshTime(10);
        localStorage.setItem("refreshTime", 10);
        return null;
      });
    let SelectedLayoutdata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
        }
        return;
      });
    if (window.location.href.split("/view/") && window.location.href.split("/view/").length > 1) {
      let dataProp = {
        id: window.location.href.split("/view/")[1].split("/")[0],
      };
      let SelectedLayoutdataProp = await httpService
        .CreateUpdate("getSelectedLayoutById", dataProp)
        .catch((err) => {
          return;
        });
      let getData = SelectedLayoutdataProp.data.data[0];
      setborderColorProp(getData.color);
      setborderWidthProp(getData.width);
    }

    if (SelectedLayoutdata?.data.data && SelectedLayoutdata?.data.data.length > 0) {
      let data = SelectedLayoutdata?.data.data[0].selectedLayout;
      if (selectedLayoutID == "") {
        setselectedLayoutID(SelectedLayoutdata?.data.data[0]._id);
      }
      setlayoutType(data);
      setlayoutCheck(true);
    }
  }
  // const checkkeylok = async () => {
  //   if (!CHECK_KEYLOK) return;
  //   let x = 1;
  //   x = await Checkkeylok_validation(x);
  //   interval = setInterval(async () => {
  //     if (!CHECK_KEYLOK) return;
  //     x = await Checkkeylok_validation(x);
  //   }, 60000);
  // };

  // const Checkkeylok_validation = async (x) => {
  //   let res = await httpService.get("checkkeylok").then((res) => res.data)
  //     .catch((err) => {
  //       setErrorMessage("Can not validate Licence File due to bad network");
  //       // setErrorPage(true);
  //       localStorage.removeItem("Username");
  //       sessionStorage.removeItem("session");
  //     });
  //   if (res === undefined || res === null) return;
  //   setLicense(res.output);
  //   if (res && res.output && res.output.tokenErr && res.output.tokenErr === 'TokenNotFound') {
  //     // user type normal or clouduser
  //     if (localStorage.getItem('UserType') == 'clouduser')
  //       setVerifyTokenUser(false)
  //     else
  //       setVerifyToken(false)
  //     localStorage.clear();
  //   }
  //   if (res.output.NumberOfLicence === '' || res.output.NumberOfLicence === '0' || res.output.isValidLicence === false) {
  //     if (res.output.msg === "LicenseNotFound") {
  //       setErrorMessage("License file not found on the server.");
  //       localStorage.removeItem("Username");
  //       sessionStorage.removeItem("session");
  //       // setErrorPage(true);
  //     } else if (res.output.msg === "licenseExpire") {
  //       setErrorMessage("License Expired, Please contact your vendor to renew it.");
  //       localStorage.removeItem("Username");
  //       sessionStorage.removeItem("session");
  //       // setErrorPage(true);
  //     } else if (res.output.msg === "invalidMacAddress") {
  //       setErrorMessage("Your MacAddress/Machine ID not match with license file, Please contact your vendor.");
  //       localStorage.removeItem("Username");
  //       sessionStorage.removeItem("session");
  //       // setErrorPage(true);
  //     }
  //   } else {
  //     if (res.output.DueDate && res.output.DueDate != (new Date()).getDate().toString()) {
  //       setErrorMessage("License Expired, Please contact your vendor to renew it.");
  //       localStorage.removeItem("Username");
  //       sessionStorage.removeItem("session");
  //       // setErrorPage(true);
  //     }
  //     else if (res.output.DueDate && x % 30 === 0) {
  //       if (localStorage.getItem("isSession") == 'true')
  //         window.confirm('Your license limit does not allow for more properties. please contact your vender to delete some properties.')
  //       // setErrorPage(false);
  //     }
  //     else {
  //       // setErrorPage(false);
  //     }
  //   }
  //   return ++x % 30;
  // };

  // useEffect(() => {
  //   if (!CHECK_KEYLOK) return;
  //   else {
  //     checkkeylok();
  //     return () => {
  //       clearInterval(interval);
  //     };
  //   }
  // }, []);
  async function getLatestdata1() {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let SelectedLayoutdata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {

        }
        return;
      });
    if (window.location.href.split("/view/") && window.location.href.split("/view/").length > 1) {
      let dataProp = {
        id: window.location.href.split("/view/")[1].split("/")[0],
      };
      let SelectedLayoutdataProp = await httpService
        .CreateUpdate("getSelectedLayoutById", dataProp)
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
          }
          return;
        });
      let getData = SelectedLayoutdataProp?.data?.data[0];
      setborderColorProp(getData.color);
      setborderWidthProp(getData.width);
    }

    if (SelectedLayoutdata?.data?.data && SelectedLayoutdata?.data?.data?.length > 0) {
      // let data = SelectedLayoutdata.data.data[0].selectedLayout;
      let data = SelectedLayoutdata?.data?.data[0]?.selectedLayout;

      if (selectedLayoutID == "") {
        setselectedLayoutID(SelectedLayoutdata?.data?.data[0]?._id);
      }
      setlayoutType(data);
      setlayoutCheck(true);
    }
  }
  // useEffect(async () => , []);

  // useEffect(() => { }, [rightContentType, layoutCheck, selectedLayoutID]);

  return (
    <Router>
      <div className="App">
        {/* {errorPage ? (
          <div>
            <LicenseError
              license={license}
              erroeMessage={errorMessage}
            ></LicenseError>
          </div>
        ) : */}
        <Switch>
          <Route path="/content/:id">
            <ProtectedRoute>
              <div>
                <Navbar setLogin={setLogin} className="navbarmain"></Navbar>
                <Preview
                  id={
                    window.location.href.split("/content/") && window.location.href.split("/content/").length > 1
                      ? window.location.href.split("/content/")[1].split("/")[0]
                      : ""
                  }
                  showProperty={true}
                  verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser}
                />
              </div>
            </ProtectedRoute>
          </Route>

          {/* // new design--- */}

          <Route path="/propertychannle/:id">
            <ProtectedRoute>
              <div>
                <Navbar setLogin={setLogin} className="navbarmain"></Navbar>
                <ChannelsListDashboard
                  id={
                    window.location.href.split("/propertychannle/") && window.location.href.split("/propertychannle/").length > 1
                      ? window.location.href.split("/propertychannle/")[1].split("/")[0]
                      : ""
                  }
                  showProperty={true}
                  verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser}
                />
              </div>
            </ProtectedRoute>
          </Route>
          {/* ------/// */}


          {/* <Route path="/content">
            <ProtectedRoute>
              <div>
                <Navbar setLogin={setLogin} className="navbarmain"></Navbar>
                {layoutCheck ? (
                  <div className="row othercomponent">
                    <div className="col-2">
                      <LeftColumn
                        rightContentType={rightContentType}
                        setrightContentType={setrightContentType}
                      ></LeftColumn>
                    </div>
                    <div className="col-10 mainright">
                      <RightColumn
                        rightContent="layout"
                        rightContentType={rightContentType}
                        setrightContentType={setrightContentType}
                        layoutType={layoutType}
                        setlayoutType={setlayoutType}
                        selectedLayoutID={selectedLayoutID}
                        setselectedLayoutID={setselectedLayoutID}
                        verifyTokenUser={verifyTokenUser}
                        setVerifyTokenUser={setVerifyTokenUser}
                      ></RightColumn>
                    </div>
                  </div>
                ) : (
                  <div className="row othercomponentLayoutSelect">
                    <LayoutSelection
                      verifyTokenUser={verifyTokenUser}
                      setVerifyTokenUser={setVerifyTokenUser}
                      setlayoutCheck={setlayoutCheck}
                    ></LayoutSelection>
                  </div>
                )}
              </div>
            </ProtectedRoute>
          </Route> */}

          <Route path="/view/:id">
            <Layout
              refreshTime={refreshTime}
              rightContentType={"layout"}
              setrightContentType={setrightContentType}
              selectedLayoutID={
                window.location.href.split("/view/") && window.location.href.split("/view/").length > 1
                  ? window.location.href.split("/view/")[1].split("/")[0]
                  : ""
              }
              setselectedLayoutID={setselectedLayoutID}
              view={true}
              preview={true}
              borderColor={borderColorProp}
              borderWidth={borderWidthProp}
              verifyTokenUser={verifyTokenUser}
              setVerifyTokenUser={setVerifyTokenUser}
            ></Layout>
          </Route>

          {/* <Route path="/shaka-player/:src" >
            <ShakaPlayer  />
          </Route> */}
          <Route path="/faq">
            <ProtectedRoute>
              <div>
                <Navbar setLogin={setLogin}></Navbar>
                <Faq></Faq>
              </div>
            </ProtectedRoute>
          </Route>

          {/* <Route path="/dashboard">
            <ProtectedRoute>
              <div>
                <Navbar setLogin={setLogin}></Navbar>
                <div className="othercomponentnavbar">
                  <Dashboard verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser} />
                </div>
              </div>
            </ProtectedRoute>
          </Route> */}
          {/* routes for the cloud user */}
          <Route path="/clouddashboard">
            <ProtectedRoute>
              <div>
                <CloudNavbar setLogin={setLogin}></CloudNavbar>
                <div className="othercomponentnavbar">
                  <CloudApp verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser} />
                </div>
              </div>
            </ProtectedRoute>
          </Route>


          <Route path="/admindashboard">
            <ProtectedRoute>
              <div>
                <AdminNavbar setLogin={setLogin}></AdminNavbar>
                <div className="">
                  <AdminApp
                    setRefreshTime={setRefreshTime}
                    refreshTime={refreshTime}
                    setVerifyToken={setVerifyToken}
                    verifyToken={verifyToken}
                  />
                </div>
              </div>
            </ProtectedRoute>
          </Route>

          <Route path="/adminlogin">
            <AdminLogin verifyToken={verifyToken} setVerifyToken={setVerifyToken} />
          </Route>
          <Route path="/uploadfile">
            <ProtectedRoute>
              <CloudNavbar setLogin={setLogin}></CloudNavbar>
              <div className="othercomponentnavbar">
                <CloudSettings
                  verifyTokenUser={verifyTokenUser}
                  setVerifyTokenUser={setVerifyTokenUser}
                />
              </div>
            </ProtectedRoute>
          </Route>
          {/* rule route  new design ---*/}
          <Route path="/rulesdashboard">
            <ProtectedRoute>
              <div>
                <CloudNavbar setLogin={setLogin}></CloudNavbar>
                <div className="othercomponentnavbar">
                  <RuleDashboard verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser} />
                </div>
              </div>
            </ProtectedRoute>
          </Route>
          <Route path="/property-manager-dashboard">
            <ProtectedRoute>
              <PropertyManagerLayout />
            </ProtectedRoute>
          </Route>
          {/* --------// */}
          <Route path="/about">
            <ProtectedRoute>
              <CloudNavbar setLogin={setLogin}></CloudNavbar>
              <div className="othercomponentnavbar">
                <Version
                />
              </div>
            </ProtectedRoute>
          </Route>
          <Route path="/cloudlogin">
            <CloudLogin verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser} />
          </Route>
          <Route path="/createUser">
            <CreateAccountPage />
          </Route>
          <Route path="/forget-password">
            <ForgetPassword />
          </Route>

          <Route path="/success">
            <PaymentSuccessful />
          </Route >
          <Route path="/fail">
            <PaymentFailed />
          </Route>

          <Route path="/">
            <CloudLogin verifyTokenUser={verifyTokenUser} setVerifyTokenUser={setVerifyTokenUser} />
          </Route>
        </Switch>
        {/* } */}
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
